// src/GalleryPage.js
import './index.css'; // optional for styling

// Array of image URLs – just edit this array to change images
const images = [
  'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSF8qJz0U8L3kHRtwDkVy83V2ShYaOGOwUuBg&s',
  'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKQt4MI0FVDN30LuEi_J2JeAK9EulrCRKzNg&s',
  'https://s3-eu-central-1.amazonaws.com/whatdesigncando/app/uploads/20181127231931/8-300x300.jpg',
  'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTR3MOM4d8wnXIKxTB0F3TVQTXS8xcXqvPv5g&s',
];

function GalleryPage() {
  return (
    <div className="gallery-container">
      <h1>Image Gallery</h1>
      <div className="gallery-grid">
        {images.map((src, index) => (
          <div className="gallery-item" key={index}>
            <img src={src} alt={`Gallery ${index + 1}`} />
          </div>
        ))}
      </div>
    </div>
  );
}

export { GalleryPage };

